import UriTemplate from 'uri-templates';

function RecaptchaService($q, halClient) {
    'ngInject';

    return {
        validateResponse(params) {
            const deferred = $q.defer();
            const href = params.api_url + '/api/v1/recaptcha';
            const uri = new UriTemplate(href);
            const prms = {};
            prms.response = params.response;
            halClient.$post(uri, {}, prms).then(response => deferred.resolve(response)
                , err => deferred.reject(err));
            return deferred.promise;
        }
    };
}

angular
    .module('BB')
    .service('RecaptchaService', RecaptchaService);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_services/recaptcha.service.js